// extracted by mini-css-extract-plugin
export default {"createButtonContainer":"PmsConfiguration_createButtonContainer__Jj+cr"};